import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_FAQS = [
  { question: "How do I post a load?", answer: "Click 'Post a Load' from the menu, fill in your details, and your load will be visible to carriers Australia-wide." },
  { question: "How do I get quotes?", answer: "Once posted, carriers can view your load and submit quotes. You'll get email notifications as quotes come in." },
  { question: "Do I need an account to post a load?", answer: "No! An account is created automatically when you post your first load." }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/faqs`)
      .then(res => setFaqs(res.data.length > 0 ? res.data : FALLBACK_FAQS))
      .catch(() => setFaqs(FALLBACK_FAQS));
  }, []);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);
  const visibleFaqs = expanded ? faqs : faqs.slice(0, 3);

  if (faqs.length === 0) return null;

  return (
    <div className="bg-[#f8f9fa] border-b border-gray-200" data-testid="faq-section">
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <h2 className="text-lg sm:text-xl font-bold text-[#1e3a5f] mb-4 text-center">Frequently Asked Questions</h2>
        <div className="max-w-3xl mx-auto space-y-2">
          {visibleFaqs.map((faq, i) => (
            <div key={faq.id || i} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50 transition-colors"
                data-testid={`faq-item-${i}`}
              >
                <span className="font-medium text-sm sm:text-base text-gray-800 pr-4">{faq.question}</span>
                {openIndex === i ? (
                  <ChevronUp className="w-4 h-4 text-gray-500 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-4 h-4 text-gray-500 flex-shrink-0" />
                )}
              </button>
              {openIndex === i && (
                <div className="px-4 pb-3 text-sm text-gray-600 border-t border-gray-100 pt-2">
                  <div className="whitespace-pre-wrap">{faq.answer}</div>
                  {faq.media && faq.media.length > 0 && (
                    <div className="flex flex-wrap gap-3 mt-3">
                      {faq.media.map(m => (
                        <div key={m.id}>
                          {m.type === 'image' ? (
                            <img src={m.data} alt={m.name || 'FAQ image'} className="max-w-xs rounded border cursor-pointer hover:opacity-80" onClick={() => window.open(m.data, '_blank')} />
                          ) : (
                            <video src={m.data} controls className="max-w-sm rounded border" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        {faqs.length > 3 && (
          <div className="text-center mt-3">
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-sm text-red-600 hover:text-red-700 font-medium"
              data-testid="faq-show-more"
            >
              {expanded ? 'Show less' : `Show all ${faqs.length} FAQs`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQSection;
